import { z } from 'zod';
import { auditFieldsShape, softDeleteShape, utcTimestampSchema, uuidSchema } from './primitives';

export const contactSchema = z.object({
  id: uuidSchema,
  name: z.string().min(1, '姓名是必填'),
  jobTitle: z.string().nullable(),
  contactTypeId: uuidSchema.nullable(),
  relationshipId: uuidSchema.nullable(),
  organization: z.string().nullable(),
  department: z.string().nullable(),
  phone: z.string().nullable(),
  email: z.string().nullable(),
  note: z.string().nullable(),
  tagIds: z.array(uuidSchema),
  ...softDeleteShape,
  ...auditFieldsShape,
});

/**
 * taskTypes、sourceTypes、tags、contactTypes、relationships 五張表共用此結構。
 * 分類**不可刪除，只能停用**，藉此消除一整類孤兒參照（data-model 4.2）。
 */
export const classificationSchema = z.object({
  id: uuidSchema,
  name: z.string().min(1),
  order: z.number().int().nonnegative(),
  color: z.string().nullable(),
  disabledAt: utcTimestampSchema.nullable(),
  ...auditFieldsShape,
});

export type Contact = z.infer<typeof contactSchema>;
export type Classification = z.infer<typeof classificationSchema>;
